import React from 'react';
import { Link } from 'react-router-dom';

const SidebarNav = ({ sections, activeSection, onSectionChange }) => {
    return (
        <nav className="bg-white/85 backdrop-blur rounded-3xl shadow-[0_10px_40px_-28px_rgba(15,23,42,0.18)] border border-slate-200/90 overflow-hidden dark:bg-slate-900/60 dark:border-slate-700/70">
            <div className="px-5 py-4 border-b border-slate-200/70 bg-gradient-to-b from-slate-50/80 to-white dark:border-slate-700/60 dark:from-slate-900/40 dark:to-slate-900/10">
                <h3 className="text-sm font-semibold tracking-wide text-slate-900 dark:text-slate-100">Documentation</h3>
                <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">Navigation par sections</p>
            </div>
            <ul className="p-3 space-y-1.5 max-h-[calc(100vh-12rem)] overflow-y-auto overscroll-contain">
                {sections.map((section) => (
                    <li key={section.id}>
                        <button
                            onClick={() => onSectionChange(section.id)}
                            className={`group w-full text-left px-3 py-2.5 rounded-2xl border transition-all duration-200 text-sm leading-snug hover:-translate-y-px active:scale-[0.99] ${
                                activeSection === section.id
                                    ? 'bg-amber-50 text-amber-900 border-amber-200/90 font-semibold shadow-sm dark:bg-amber-500/10 dark:text-amber-200 dark:border-amber-400/25'
                                    : 'text-slate-700 hover:text-slate-900 hover:bg-slate-50 border-transparent hover:border-slate-200/80 dark:text-slate-200 dark:hover:bg-slate-800/50 dark:hover:border-slate-700/70'
                            }`}
                        >
                            <span className="block break-words line-clamp-2">{section.title}</span>
                            {activeSection === section.id ? (
                                <span className="mt-1 block text-[11px] text-amber-700/90 dark:text-amber-200/90">
                                    Section active
                                </span>
                            ) : null}
                        </button>
                    </li>
                ))}
            </ul>

            {/* Quick Links */}
            <div className="px-5 py-4 pt-3 border-t border-slate-200/70 bg-slate-50/40 dark:border-slate-700/60 dark:bg-slate-900/20">
                <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-[0.18em] mb-2 dark:text-slate-400">Procédures</h4>
                <div className="space-y-1.5">
                    <Link to="/authentication" className="block text-sm text-amber-700 hover:text-amber-800 transition-colors py-1 dark:text-amber-300 dark:hover:text-amber-200">
                        Authentification
                    </Link>
                    <Link to="/payment-flow" className="block text-sm text-amber-700 hover:text-amber-800 transition-colors py-1 dark:text-amber-300 dark:hover:text-amber-200">
                        Flux de Paiement
                    </Link>
                    <Link to="/error-codes" className="block text-sm text-amber-700 hover:text-amber-800 transition-colors py-1 dark:text-amber-300 dark:hover:text-amber-200">
                        Codes d'Erreur
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default SidebarNav;